import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { MainLayout } from "../mainLayout";
import { SingleLayout } from "../singleLayout";
import { IntroHeader } from "../pages/IntroHeader";
import { OmOss } from "../pages/OmOss";
import { WorkWithUs } from "../pages/workWithUs";
import { PrivacyPolicy } from "../utils/privacy";
import { NotFound } from "../utils/notFound";
import { CookieComponent } from "../utils/cookies";
import { ScrollToTop } from "./scrollTo";
import { LandingpageWebb } from "../landingpage/landingPage";
import { CookiePolicy } from "./cookie-info";
import { Tack } from "../landingpage/tack";
import { Konsulter } from "../pages/konsulter";
import { RecCustomer } from "../pages/Kunder";
import { TheServices } from "../pages/Tjanster";
import { IntroOmOss } from "../pages/intro-OmOss";
import { CMSInfo } from "../pages/CmsInfo";
import { SeoInfo } from "../pages/SeoInfo";
import { UxUiInfo } from "../pages/UxUiInfo";
import { Webbutveckling } from "../pages/Webbutveckling";
import { HostingInfo } from "../pages/HostingForvaltning";
import { ATPartner } from "../pages/atPartner";

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <MainLayout>
              <IntroHeader />
              <RecCustomer />
              <TheServices />
              <IntroOmOss />
            </MainLayout>
          }
        />

        <Route
          path="/webbutveckling/cms-info"
          element={
            <MainLayout>
              <CMSInfo />
            </MainLayout>
          }
        />
        <Route
          path="/webbutveckling/seo-info"
          element={
            <MainLayout>
              <SeoInfo />
            </MainLayout>
          }
        />
        <Route
          path="/webbutveckling/uxui-info"
          element={
            <MainLayout>
              <UxUiInfo />
            </MainLayout>
          }
        />
        <Route
          path="/webbutveckling/hosting-info"
          element={
            <MainLayout>
              <HostingInfo />
            </MainLayout>
          }
        />

        <Route
          path="/webbutveckling"
          element={
            <MainLayout>
              <Webbutveckling />
            </MainLayout>
          }
        />

        <Route
          path="/konsulter"
          element={
            <MainLayout>
              <Konsulter />
            </MainLayout>
          }
        />

        <Route
          path="/at-partner"
          element={
            <MainLayout>
              <ATPartner />
            </MainLayout>
          }
        />

        <Route
          path="/om-oss"
          element={
            <MainLayout>
              <OmOss />
            </MainLayout>
          }
        />

        <Route
          path="/workwithus"
          element={
            <MainLayout>
              <WorkWithUs />
            </MainLayout>
          }
        />

        <Route
          path="/privacy"
          element={
            <MainLayout>
              <PrivacyPolicy />
            </MainLayout>
          }
        />

        <Route
          path="/cookies"
          element={
            <MainLayout>
              <CookiePolicy />
            </MainLayout>
          }
        />

        <Route
          path="/webbutveckling-hemsidor"
          element={
            <MainLayout>
              <LandingpageWebb />
            </MainLayout>
          }
        />

        <Route
          path="/tack"
          element={
            <MainLayout>
              <Tack />
            </MainLayout>
          }
        />

        <Route
          path="*"
          element={
            <SingleLayout>
              <NotFound />
            </SingleLayout>
          }
        />
      </Routes>
      <CookieComponent />
    </Router>
  );
};

export default AppRoutes;
